module.exports = __webpack_public_path__ + "static/media/2.d9180da4.jpg";